import { LoaderFunctionArgs, redirect } from 'react-router-dom'

import { createStationQueryOptions } from '@/api/stations/options'

import { queryClient } from '@/config/react-query'

import { HttpError } from '@/api/http'
import { AppRoutes } from '@/routes/types/routes'
import { Logger } from '@/lib/logger'

const logger = new Logger('StationLoader')

export default async ({ params }: LoaderFunctionArgs) => {
  logger.info('Carregando estação', params)

  const redirectWithReason = (reason: string) => redirect(`${AppRoutes.STATIONS}?error=${encodeURIComponent(reason)}`)

  try {
    const station = await queryClient.ensureQueryData(createStationQueryOptions({ id: Number(params.stationId) }))

    logger.info('Estação carregada com sucesso', station)
    return station
  } catch (error) {
    if (error instanceof HttpError && error.status === 404) {
      logger.error('Estação não encontrada (404)', { error, params })
      throw redirectWithReason('Estação não encontrada.')
    }

    if (error instanceof HttpError && error.status === 403) {
      logger.error('Estação indisponível (403)', { error, params })
      throw redirectWithReason(error.message)
    }

    logger.error('Erro ao carregar estação', { error, params })
    throw error
  }
}
